import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { fetchDeprecationPlans } from '../service/deprecationPlanService'
import { deprecationPlanQueryKeys } from './deprecationPlanQueryKeys'

interface UseDeprecationPlansParams {
  budgetingScenarioId?: number | null
  enabled?: boolean
}

/**
 * Fetch all deprecation plans for the current company and budgeting scenario
 * Used by DeprecationPlanContext to load all plans at once
 */
export const useDeprecationPlans = (params?: UseDeprecationPlansParams) => {
  const companyId = useSelector(contextCompanyIdSelector)
  const { dimensionsQuery } = useSelector(filtersSelector)
  const { budgetingScenarioId, enabled = true } = params || {}

  return useQuery({
    queryKey: deprecationPlanQueryKeys.list(companyId!, budgetingScenarioId),
    queryFn: () => fetchDeprecationPlans(companyId!, budgetingScenarioId, dimensionsQuery),
    enabled: !!companyId && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes - deprecation plans don't change often
    gcTime: 10 * 60 * 1000 // 10 minutes
  })
}
